import React from 'react';
import { Box, Typography } from '@mui/material';

const Groups: React.FC = () => (
  <Box sx={{ color: '#fff', p: 4 }}>
    <Typography variant="h4">Groups</Typography>
    <Typography sx={{ mt: 2 }}>Groups page (stub)</Typography>
  </Box>
);

export default Groups;
